import * as actions from "../actions";
import * as actionsTypes from "../actionTypes";
import { all, fork, put, takeEvery } from "redux-saga/effects";
import InvoicesService from '../../services/invoices.service'

function* getInvoicesList(action) {
  try {
    if (action.payload) {
      const page = action.payload?.pageNo;
      const pageSize = action.payload?.pageSize;
      const search = action.payload?.search;
      let params = { page, pageSize, search };
      const response = yield InvoicesService.list(action.payload);
      if (response?.data.statusCode) {
        yield put(actions.getInvoicesListSuccess(response?.data?.data));
      } else {
        yield put(actions.getInvoicesListFailure("no data"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message;
    if (!error) {
      error = err?.response?.message || "network error"
    }
    yield put(actions.getInvoicesListFailure(error));
  }
}

function* getInvoicesListSaga() {
  yield takeEvery(actionsTypes.GET_INVOICES_LIST_START, getInvoicesList);
}

function* generateInvoice(action) {
  try {
    if (action.payload) {
      const createNew = action.payload.createNew;
      let response = null;

      if (createNew) {
        const data = action.payload.data
        response = yield InvoicesService.create(data);
      } else {
        let data = ''
        const id = action.payload.id
        if (action.payload.file) {
          data = new FormData()
          data.append('file', action.payload.file)
          data.append('status', action.payload.status)
        } else {
          if (action.payload.status == 10 && action.payload.deposit_slip) {
            data = new FormData()
            data.append('cp_name', action.payload.cp_name);
            data.append('deposit_slip', action.payload.deposit_slip);
            data.append('email', action.payload.email);
            data.append('email1', action.payload.email1);
            data.append('gross_revenue', action.payload.gross_revenue);
            data.append('end_date', action.payload.end_date);
            data.append('html', action.payload.html);
            data.append('label_revenue', action.payload.label_revenue);
            data.append('start_date', action.payload.start_date);
            data.append('status', action.payload.status);
            data.append('subject', action.payload.subject);
          }
          else
            data = action.payload;
        }
        response = yield InvoicesService.update(id, data);

      }

      // console.log({response})
      if (response?.data.statusCode) {
        // console.log(response.data)
        yield put(actions.generateInvoiceSuccess(response?.data));
      } else {
        yield put(actions.generateInvoiceFailure("no data"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message;
    if (!error) {
      error = err?.response?.message || "network error"
    }
    yield put(actions.generateInvoiceFailure(error));
  }
}

function* generateInvoiceSaga() {
  yield takeEvery(actionsTypes.GENERATE_INVOICE_START, generateInvoice);
}


function* getInvoicesReportList(action) {
  try {
    if (action.payload) {
      const page = action.payload?.pageNo;
      const pageSize = action.payload?.pageSize;
      const search = action.payload?.search;
      let params = { page, pageSize, search };
      const response = yield InvoicesService.reportList(action.payload);
      if (response?.data.statusCode) {
        yield put(actions.getInvoicesReportListSuccess(response?.data?.data));
      } else {
        yield put(actions.getInvoicesReportListFailure("no data"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message;
    if (!error) {
      error = err?.response?.message || "network error"
    }
    yield put(actions.getInvoicesReportListFailure(error));
  }
}

function* getInvoicesReportListSaga() {
  yield takeEvery(actionsTypes.GET_INVOICES_REPORT_LIST_START, getInvoicesReportList);
}

function* getLabelInvoiceList(action) {
  try {
    if (action.payload) {
      // const page = action.payload?.pageNo;
      // const pageSize = action.payload?.pageSize;
      // const search = action.payload?.search;
      // let params = {page, pageSize, search};
      const response = yield InvoicesService.labelsList(action.payload);
      // console.log(response)
      if (response?.data.statusCode) {
        yield put(actions.getLabelInvoicesListSuccess(response?.data?.data));
      } else {
        yield put(actions.getLabelInvoicesListFailure("no data"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message;
    if (!error) {
      error = err?.response?.message || "network error"
    }
    yield put(actions.getLabelInvoicesListFailure(error));
  }
}

function* getLabelInvoiceListSaga() {
  yield takeEvery(actionsTypes.GET_LABEL_INVOICES_LIST_START, getLabelInvoiceList);
}

export function* invoicesSaga() {
  yield all([fork(getInvoicesListSaga), fork(generateInvoiceSaga), fork(getInvoicesReportListSaga), fork(getLabelInvoiceListSaga),]);
}
